"use client"

import { Form, Formik } from "formik"
import { FormSelect } from "@/components/form-inputs"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"

type AddDisclosureLanguageDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  languages: ReadonlyArray<{ value: string; label: string }>
  onAdd: (language: string) => void
}

export function AddDisclosureLanguageDialog({ open, onOpenChange, languages, onAdd }: AddDisclosureLanguageDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add language</DialogTitle>
          <DialogDescription>Choose a language, then edit and save its announcement wording in the table.</DialogDescription>
        </DialogHeader>
        <Formik
          initialValues={{ language: languages[0]?.value ?? "" }}
          enableReinitialize
          onSubmit={async ({ language }) => {
            if (!languages.some(option => option.value === language)) return
            onAdd(language)
            onOpenChange(false)
          }}
        >
          {formik => (
            <Form className="space-y-4">
              <FormSelect name="language" label="Language" options={languages} placeholder="Choose a language" />
              <DialogFooter>
                <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
                <Button type="submit" disabled={!formik.values.language || formik.isSubmitting}>Add language</Button>
              </DialogFooter>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}
